import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic-monitoring-discipline-committee',
  templateUrl: './academic-monitoring-discipline-committee.component.html',
  styleUrls: ['./academic-monitoring-discipline-committee.component.scss']
})
export class AcademicMonitoringDisciplineCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
